// preauthorized-offer.reducer.ts
import { createReducer, on } from '@ngrx/store';
import { get, save, remove } from 'src/app/data/utils/localstorage.util';
import { PreauthorizedOffer } from 'src/app/models/state/preauthorized-offer.model';
import {
	selectOfferData,
	addSelectedAmount,
	addSelectedTerm,
	clearOfferState,
	setOfferData,
	setCurpFlowIdentity,
} from '../actions/preauthorized-offer.actions';

const PREAUTHORIZED_OFFER_KEY = 'PreauthorizedOfferState';

const initialState: PreauthorizedOffer = {
	offerName: {
		name: '',
		firstSurname: '',
		secondSurname: '',
	},
	offerPersonId: 0,
	offerPersonType: 1,
	preauthorizedMount: 80000,
	selectedAmount: 0,
	selectedTerm: 0,
	folioDigital: '',
	productCobisId: '',
	applicantPhone: '',
	isApplicantAMember: false,
	rate: 52.08,
	term: 48,
};

const getInitialState = (initial: PreauthorizedOffer): PreauthorizedOffer => {
	const stateFromStorage = get<PreauthorizedOffer>(PREAUTHORIZED_OFFER_KEY);
	return stateFromStorage !== null ? stateFromStorage : initial;
};

export const preauthorizedOfferReducer = createReducer(
	getInitialState(initialState),

	on(selectOfferData, (state, payload): PreauthorizedOffer => {
		const newState = { ...state, ...payload };
		saveStateToLocalStorage(newState);
		return newState;
	}),

	on(addSelectedAmount, (state, { selectedAmount }) => {
		const newState = { ...state, selectedAmount };
		saveStateToLocalStorage(newState);
		return newState;
	}),

	on(addSelectedTerm, (state, { selectedTerm }) => {
		const newState = { ...state, selectedTerm };
		saveStateToLocalStorage(newState);
		return newState;
	}),

	on(setCurpFlowIdentity, (state, { offerPersonId, productCobisId, folioDigital, isApplicantAMember }): PreauthorizedOffer => {
		const newState = { ...state, offerPersonId, productCobisId, folioDigital, isApplicantAMember };
		saveStateToLocalStorage(newState);
		return newState;
	}),

	on(clearOfferState, () => {
		remove(PREAUTHORIZED_OFFER_KEY);
		return initialState;
	}),

	on(setOfferData, (state, { offer }): PreauthorizedOffer => {
		const newState = { ...state, ...offer };
		saveStateToLocalStorage(newState);
		return newState;
	})
);

function saveStateToLocalStorage(state: PreauthorizedOffer) {
	save<PreauthorizedOffer>(PREAUTHORIZED_OFFER_KEY, state);
}
